import React, { useState, useEffect } from 'react';
import { Row, Col, Rate, message } from 'antd';
import ModalItem from '../../../../Components/ModalItem';
import ButtonItem from '../../../../Components/ButtonItem';
import axios from 'axios';

const ModalCalificacionProveedor = ({
  visible,
  proveedor,
  onCancel,
  empresaId,
  headersToken,
}) => {
  const [calificaciones, setCalificaciones] = useState({
    precio: 0,
    calidad: 0,
    servicio: 0,
    tiempoEntrega: 0,
  });

  // Cargar valores cuando se abre el modal
  useEffect(() => {
    if (visible && proveedor) {
      setCalificaciones({
        precio: proveedor.califPrecio || 0,
        calidad: proveedor.califCalidad || 0,
        servicio: proveedor.califServicio || 0,
        tiempoEntrega: proveedor.califTmpEntrega || 0,
      });
    }
  }, [visible, proveedor]);

  const actualizarCalificacion = (aspecto, valor) => {
    setCalificaciones((prev) => ({
      ...prev,
      [aspecto]: valor,
    }));
  };

  const guardarCalificacionDetallada = () => {
    if (!proveedor) return;

    const promedio =
      (calificaciones.precio +
        calificaciones.calidad +
        calificaciones.servicio +
        calificaciones.tiempoEntrega) / 4;

    axios
      .post(
        "proveedores/guardarCalificacionDetallada",
        {
          proveedorId: proveedor._id,
          calificacionDetalle: calificaciones,
          promedioCalificacion: Math.round(promedio * 10) / 10,
          empresaId: empresaId,
        },
        { headers: headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success('Calificación detallada guardada correctamente');
          onCancel();
        } else {
          message.error("Error al guardar la calificación detallada");
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al guardar la calificación detallada");
      });
  };

  const promedio =
    (calificaciones.precio +
      calificaciones.calidad +
      calificaciones.servicio +
      calificaciones.tiempoEntrega) / 4;

  return (
    <ModalItem
      title={`Evaluar Proveedor: ${proveedor?.nombre || proveedor?.razonSocial || ''}`}
      visible={visible}
      onCancel={onCancel}
      spinning={false}
      width={600}
      
    >
      <div style={{ padding: '20px 0' }}>
        <Row gutter={[0, 24]}>
          {["precio", "calidad", "servicio", "tiempoEntrega"].map((aspecto) => (
            <Col span={24} key={aspecto}>
              <Row align="middle">
                <Col span={8}>
                  <strong>{aspecto.charAt(0).toUpperCase() + aspecto.slice(1)}:</strong>
                </Col>
                <Col span={12}>
                  <Rate
                    value={calificaciones[aspecto]}
                    onChange={(value) => actualizarCalificacion(aspecto, value)}
                    allowHalf
                    style={{ fontSize: 20 }}
                  />
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                  <span style={{ color: '#666' }}>{calificaciones[aspecto]}/5</span>
                </Col>
              </Row>
            </Col>
          ))}

          <Col span={24}>
            <div
              style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px',
                textAlign: 'center',
              }}
            >
              <strong>Promedio General: </strong>
              <Rate
                value={promedio}
                disabled
                allowHalf
                style={{ fontSize: 18, color: '#1890ff' }}
              />
              <div style={{ marginTop: '5px', fontSize: '16px', fontWeight: 'bold' }}>
                {promedio.toFixed(1)}/5
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ textAlign: 'right', marginTop: 20,marginBottom: 2 }}>
    <ButtonItem onClick={onCancel} rojo style={{ marginRight: 8 }}>
      Cancelar
    </ButtonItem>
    <ButtonItem onClick={guardarCalificacionDetallada}>
      Guardar Calificación
    </ButtonItem>
  </div>
    </ModalItem>
  );
};

export default ModalCalificacionProveedor;
